import { type ISignResponse } from '../../../../../models/sign-response';

export class SignResponseApiModel {
  public static mapToBusinessModel(apiModel: SignResponseApiModel): ISignResponse {
    return {
      autoStartToken: apiModel.autoStartToken,
      orderRef: apiModel.orderRef,
      qrCode: apiModel.qrCode,
      transactionId: apiModel.transactionId,
    };
  }

  public autoStartToken!: string;
  public orderRef!: string;
  public qrCode!: string;
  public transactionId!: string;
}
